import { render, staticRenderFns } from "./DanceGUI.vue?vue&type=template&id=08ed7ec8&"
import script from "./DanceGUI.vue?vue&type=script&lang=js&"
export * from "./DanceGUI.vue?vue&type=script&lang=js&"
import style0 from "./DanceGUI.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports